/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityRequest } from '../../models/facility-request';
import { FacilityResponse } from '../../models/facility-response';

export interface UpdateFacility$Params {
  facilityId: number;
      body: FacilityRequest
}

export function updateFacility(http: HttpClient, rootUrl: string, params: UpdateFacility$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityResponse>> {
  const rb = new RequestBuilder(rootUrl, updateFacility.PATH, 'put');
  if (params) {
    rb.path('facilityId', params.facilityId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FacilityResponse>;
    })
  );
}

updateFacility.PATH = '/api/facility/{facilityId}';
